var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ispages"},[_c('div',{staticClass:"consumption"},[_c('div',{staticClass:"consumption-items"},_vm._l((_vm.exercise),function(item,index){return _c('div',{key:index,staticClass:"list-main"},[_c('img',{attrs:{"src":item.url,"alt":""}}),_c('div',[_vm._v(_vm._s(item.name)+_vm._s(item.num)+"分钟")])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }